import React from "react";
import styled, { css } from "styled-components";

const StyledIconBtn = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 2px;
  background-color: transparent;

  /* only have hover and activation
  if not disabled */
  ${props =>
    !props.disabled &&
    css`
      &:hover {
        background-color: ${({ theme }) => theme.colors.gray200};
      }
      &:active {
        background-color: ${({ theme }) => theme.colors.gray400};
      }
    `}
`;

const IconBtn = ({ children, className, onClick, disabled }) => {
  // pass the disabled prop to children
  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, { disabled })
  );
  return (
    <StyledIconBtn onClick={onClick} className={className} disabled={disabled}>
      {childrenWithProps}
    </StyledIconBtn>
  );
};

IconBtn.defaultProps = {
  disabled: false
};

export default IconBtn;
